<template>
  <div class="header">
    <div class="content">
      <img src="../assets/img/logo.png" alt="">
      <div class="nav">
        <div v-for="item in navList" :key="item.path" class="nav-item" :class="{active: activePath === item.path || hoverPath === item.path || $route.name === item.path}" @click="jump(item.path)" @mouseenter="hoverPath = item.path" @mouseleave="hoverPath = ''">
          {{ item.name }}
        </div>
      </div>
      <div class="nav-input">
        <input v-model="keywords" type="text" placeholder="请输入关键字">
        <el-select class="searchType" v-model="searchType" placeholder="选择类型" style="width: 80px;vertical-align: top;display: inline-block;margin-top: -2px">
          <el-option v-for="(value, key) in searchTypeList" :key="key" :label="value" :value="key" />
        </el-select>
        <i class="el-icon-search" @click="search"></i>
      </div>
      <div v-if="!token" class="right-button">
        <span @click="toLoginCenter(1)">登录</span> | <span @click="toLoginCenter(0)">注册</span>
      </div>
      <div v-else class="right-button">
        <span :class="{on: $route.path.includes('userCenter')}" @click="$router.push('/userCenter'), activePath = ''">个人中心</span> | <span @click="logout">退出</span>
      </div>
    </div>

    <el-dialog class="ssoiframe" v-if="isShowSSoIframe" :visible.sync="isShowSSoIframe" :width="ssowidth+'px'" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
      <SsoIframe :url="ssoIframeUrl" :ssoheight="ssoheight" :ssowidth="ssowidth" />
    </el-dialog>

    <el-dialog title="提示" :visible.sync="toSsoDialog" width="30%" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
      <span>{{ssoMsg}}{{ssoStatus === 10113 || ssoStatus === 10006 || ssoStatus === 10008 ?'，点击确定将跳转个人用户中心重新登录。':''}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ssoStatus === 10113 || ssoStatus === 10006 || ssoStatus === 10008 ? toLoginCenter(1):toSsoDialog = false ">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import SsoIframe from './SsoIframe.vue'
import {
  mapState
} from 'vuex'
import CryptoJS from 'crypto-js'
import { removeToken, setToken } from '../utils/cookie'
import CONFIG from '@/utils/urlConfig.js'
export default {
  name: 'Header',
  data () {
    return {
      searchType: 'activity',
      searchTypeList: {
        activity: '活动',
        specialCourse: '课程',
        tutor: '导师',
        society: '资讯'
      },
      keywords: '',
      activePath: '',
      hoverPath: '',
      navList: [
        {
          path: 'homepage',
          name: '首页'
        },
        {
          path: 'product',
          name: '产品研习堂'
        },
        {
          path: 'operation',
          name: '运维能力课'
        },
        {
          path: 'capital',
          name: '资本对接营'
        },
        {
          path: 'tutor',
          name: '导师星空'
        },
        {
          path: 'about',
          name: '关于我们'
        }
      ],
      isShowSSoIframe: false,
      ssoIframeUrl: false,
      ssoheight: undefined,
      ssowidth: undefined,
      toSsoDialog: false,
      ssoMsg: undefined,
      ssoStatus: undefined
    }
  },
  components: {
    SsoIframe
  },
  computed: {
    ...mapState(['userData']),
    ...mapState(['token'])
  },
  mounted () {
    setTimeout(() => {
      console.log(this.$route)
      if (this.$route.query.pathList && JSON.parse(this.$route.query.pathList).length > 0) {
        this.navList.forEach(item => {
          if (JSON.parse(this.$route.query.pathList)[0].path.includes(item.path)) {
            this.activePath = item.path
          }
        })
      }
      //   if (this.$route.query.token || this.$route.query.code) {
      //     let token = this.$route.query.code || this.$route.query.token
      //     this.$post('/front/userCenter/user', { token: token }).then(res => {
      //       if (res) {
      //         setToken(res.token)
      //         this.$store.commit('setUserData', res.user)
      //         localStorage.setItem('userData', JSON.stringify(res.user))
      //         this.$store.commit('setToken', res.token)
      //         let originPath = this.$route.fullPath.split('code')[0]
      //         this.$router.push(originPath);
      //       }
      //     })
      //   }
    }, 300)

    window.addEventListener('message', (res) => {
      console.log(res)
      if (res.data) {
        if (res.data.data.status === 10001) {
          this.ssoLoginCandle(res.data.data.token)
          this.isShowSSoIframe = false
        } else if (res.data.data.status === 10002) {
          this.$store.commit("setUserData", "");
          this.$store.commit("setToken", "");
          localStorage.removeItem("userData");
          this.toLoginCenter(1)
        } else if (res.data.data.status === 10003) {
          this.$store.commit("setUserData", "");
          this.$store.commit("setToken", "");
          localStorage.removeItem("userData");
          this.toLoginCenter(1)
        }
        else if (res.data.data.status === 10113) {
          this.toSsoDialog = true
          this.ssoStatus = 10113
          this.ssoMsg = res.data.data.msg
        }
        else if (res.data.data.status === 10114) {
          this.toSsoDialog = true
          this.ssoStatus = 10114
          this.ssoMsg = res.data.data.msg
        }
        else if (res.data.data.status === 10006) {
          // 解除自己
          this.toSsoDialog = true
          this.ssoStatus = 10006
          this.ssoMsg = '解除成功'
        }
        else if (res.data.data.status === 10007) {
          // 解除别人
          this.$message.success('解绑成功')
        }
        else if (res.data.data.status === 10008) {
          // 解除自己
          this.toSsoDialog = true
          this.ssoStatus = 10008
          this.ssoMsg = '设置成功'
        }
      }
    }, false);
    // this.creatQrCode();

    console.log(this.curIndex)
    const t = JSON.parse(localStorage.getItem('userData') || sessionStorage.getItem('userData') || '{}')
    this.$store.commit('setUserData', t)
    setTimeout(() => {
      //   if (this.userData && this.userData.token) {
      //     const urlKey = t.userType === 'company' ? 'companyUser' : 'investUser'
      //     this.$axios({
      //       method: 'post',
      //       url: `${process.env.VUE_APP_BASE_API}/front/${urlKey}/home`,
      //       hideMsg: true
      //     }).then((res) => {

      //       if (res.code == 200 && res.msg === '请重新登录') {
      //         console.log('清空')
      //         this.$store.commit('setUserData', '')
      //         this.$store.commit('setToken', '')
      //         localStorage.removeItem('userData')
      //         sessionStorage.removeItem('userData')
      //         removeToken()
      //         return
      //       }

      //       if (+res.code === 100) {
      //         this.curIndex = Number(sessionStorage.getItem('nj_web_head_index') || '0')
      //         this.$store.commit('setHeadIndex', this.curIndex)

      //         // eslint-disable-next-line camelcase
      //         const is_from_home_page = sessionStorage.getItem('is_from_home_page') || '1'
      //         this.$store.commit('changeFrom', is_from_home_page)
      //       } else {
      //         this.logout()
      //       }
      //     }).catch((e) => {
      //       console.log('用户信息', e)
      //     })
      //   } else {


      //   }

      console.log(this.$route)
      if (this.$route.query.code) {
        this.ssoLoginCandle(this.$route.query.code)
      }
      console.log('bus', this.$bus)
      this.$bus.$on('candleSSo', (data, showType) => {

        this.toLoginCenter(data, showType)
      })
    }, 300)


  },
  methods: {
    toLoginCenter (t, showType) {

      this.$post(`${CONFIG['SSO_CONFIG'][process.env.NODE_ENV]}/front/public/info`,
        {
          callBackUrl: window.location.href.indexOf('?') > -1 ? window.location.href + '&code=' : window.location.href + '?code=',
          channelLabel: "stock",
        }).then(res => {

          if (res) {
            this.aesData(res, t, showType)
            //   window.location.href = 'http://sso.winpow.com/?secrit=' + res.msg
          }
        })
    },
    ssoLoginCandle (token) {
      window.localStorage.setItem('accessTokenSSo', token)
      let formToken = token instanceof Array ? token[0] : token
      this.$post('/front/userCenter/user', { token: formToken }).then(res => {
        if (res) {
          setToken(res.token)
          this.$store.commit('setUserData', res.user)
          localStorage.setItem('userData', JSON.stringify(res.user))
          this.$store.commit('setToken', res.token)
          let originPath = this.$route.fullPath.split('code')[0]
          this.$router.push(originPath);


        } else {
          this.$message.error(res.msg)
        }
      })
    },
    cleanActivePath () {
      this.activePath = ''
    },
    logout () {
      this.$store.commit('setUserData', '')
      this.$store.commit('setToken', '')
      localStorage.removeItem('userData')
      removeToken()
      this.$router.push('/')
    },
    jump (path) {
      if (this.$route.name !== path) {
        this.activePath = path
        this.$router.push('/' + path)
      }
    },
    search () {
      if (this.keywords === '') {
        return this.$message.error('请输入关键字 !')
      }
      if (this.searchType === '') {
        return this.$message.error('请先选择搜索类型 !')
      }
      if (this.$route.name !== 'searchResult') {
        this.$router.push({
          path: '/searchResult',
          query: {
            keywords: this.keywords,
            searchType: this.searchType
          }
        })
      } else {
        this.$message.warning('请在下方输入搜索内容 !')
      }
    },
    login (t) {
      //   this.$router.push('/login')
      this.$post(`${process.env.VUE_APP_SSO}/front/public/info`, {
        callBackUrl: window.location.href.indexOf('?') > -1 ? window.location.href + '&code=' : window.location.href + '?code=',
        channelLabel: "ycxs",

      }).then(res => {
        console.log(res)
        if (res.channelId) {
          this.aesData(res, t)
          //   window.location.href = 'http://sso.winpow.com/?secrit=' + res.msg
        }
      })
    },

    aesData (data, t, showType) {
      console.log(t)
      data.type = t
      if (t == 6 || t == 7 || t == 8 || t == 9) {

        data.cellPhone = this.userData.userPhone
        data.userType = this.userData.manageState == '1' ? 'admin' : 'common'
        data.pkid = this.userData.pkid
      }
      data.accessToken = localStorage.getItem('accessTokenSSo') || undefined
      data.channelId = '0634c7b7eae011ed8aaed09466462d8f'
      data.showType = showType || undefined

      var aseKey = "UJHyueIOJ321fds2"
      var message = JSON.stringify(data)
      var encrypt = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(aseKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      console.log("加密为：", encodeURIComponent(encrypt))
      let url = CONFIG['SSO_CONFIG'][process.env.NODE_ENV] + '/?secrit=' + encodeURIComponent(encrypt)
      if (showType === 'window' && t == 7) {
        // window.open(url, '_blank')
        this.isShowSSoIframe = true
        this.ssoIframeUrl = url
        this.ssoheight = '580'
        this.ssowidth = '465'
      } else if (showType === 'window' && t == 6) {
        // window.open(url, '_blank')
        this.isShowSSoIframe = true
        this.ssoIframeUrl = url
        this.ssoheight = '580'
        this.ssowidth = '465'
      }
      else if (showType === 'window' && t == 8) {
        this.isShowSSoIframe = true
        this.ssoIframeUrl = url
        this.ssoheight = '580'
        this.ssowidth = '465'
      }
      else if (showType === 'window' && t == 9) {
        this.isShowSSoIframe = true
        this.ssoIframeUrl = url
        this.ssoheight = '580'
        this.ssowidth = '700'
      }
      else {
        window.location.href = url
      }
    },


    register () {
      window.open(this.$winpowUrl + '/user/register.html?type=school', '_blank')
    }
  },
  watch: {
    token (val) {
    },
    $route (val) {
      if (this.$route.query.pathList && JSON.parse(this.$route.query.pathList).length > 0) {
        this.navList.forEach(item => {
          if (JSON.parse(this.$route.query.pathList)[0].path.includes(item.path)) {
            this.activePath = item.path
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 80px;
  background-color: #fefefe;
  .content {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    img {
      width: 188px;
      height: 80px;
    }
    div {
      display: inline-block;
      vertical-align: top;
    }
    .nav {
      margin: 0 20px;
      .nav-item {
        height: 80px;
        line-height: 80px;
        padding: 0 14px;
        cursor: pointer;
      }
      .active {
        color: #ffffff;
        background-color: #ea5504;
      }
    }
    .nav-input {
      width: 240px;
      height: 36px;
      line-height: 32px;
      border: 1px solid #999999;
      border-radius: 18px;
      margin-top: 22px;
      overflow: hidden;
      input {
        width: 110px;
        margin-left: 18px;
        height: 30px;
        border: none;
        outline: none;
      }
      i {
        font-size: 22px;
        vertical-align: middle;
        color: #666666;
        cursor: pointer;
        margin-left: 5px;
      }
      i:hover {
        color: #ea5504;
      }
    }
    .right-button {
      float: right;
      line-height: 80px;
      font-size: 18px;
      span {
        cursor: pointer;
      }
      span:hover {
        color: #ea5504;
      }
      .on {
        color: #ea5504;
      }
    }
    .personCenter {
      float: right;
      width: 80px;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #ffffff;
      background-color: #ea5504;
      border-radius: 3px;
      text-align: center;
      vertical-align: middle;
      margin-top: 25px;
      cursor: pointer;
    }
    .personCenter:hover {
      opacity: 0.8;
    }
    .logout {
      float: right;
      width: 58px;
      height: 28px;
      line-height: 30px;
      font-size: 16px;
      color: #ea5504;
      background-color: #ffffff;
      border: 1px solid #ea5504;
      border-radius: 3px;
      text-align: center;
      vertical-align: middle;
      margin-top: 25px;
      margin-left: 10px;
      cursor: pointer;
    }
    .logout:hover {
      opacity: 0.8;
    }
  }
}

.ssoiframe::v-deep {
  top: calc(50% - 800px);
  .el-dialog {
    border-radius: 16px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
    z-index: 2;
    position: relative;
  }

  .el-dialog__wrapper {
  }
}
</style>
